import { Outlet } from '@tanstack/react-router'
import { Hotjar } from '@/common/components/hotjar'
import { REDACT_ATTRS } from '@/common/analytics'
import * as styles from '@/common/components/authenticated-layout/AuthenticatedLayout.css'

// Auth checks and cross-tab sync are handled by AuthSyncAndRedirect in __root.tsx
export const Route = createFileRoute({
  component: AuthMinimalLayout,
})

export function AuthMinimalLayout() {
  // Authenticated layout WITHOUT Navbar (for onboarding/agreement).
  //
  // Global DOM redaction baseline (defense-in-depth).
  // Mirrors AuthenticatedLayout's shell root: this second authenticated shell
  // hosts PII-heavy onboarding/agreement content (e.g. the TypeToSign input
  // whose `placeholder`/`value` echo the investor's legal name), so it carries
  // the same baseline. `data-heap-redact-text` masks all in-shell text from
  // autocapture, and `data-heap-redact-attributes` masks the listed attribute
  // values; both cascade to the whole subtree below this root. Heap still
  // records that an event happened and on what route — only sensitive CONTENT
  // is replaced with `****`.
  //
  // NOTE: like the main shell, this does NOT cover portal-rendered subtrees
  // (Radix dialogs mount outside this container) — those carry field-level
  // <Redact>.
  return (
    <div
      className={styles.layout}
      data-heap-redact-text="true"
      data-heap-redact-attributes={REDACT_ATTRS}
    >
      <Hotjar />
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  )
}
